// extracted by mini-css-extract-plugin
export default {"root":"Inactive_root__aXccG"};